import React, { useState, useEffect, useRef } from 'react';
import ChallengeEligibilityCheckerService from 'services/challenge-eligibility-checker.service';
import AuthService from 'services/auth.service';
import { Form, Modal, Button } from "react-bootstrap";

function ChallengeEligibilityChecker({chat}) {
  const [markEligibleForChallengeAt, setMarkEligibleForChallengeAt] = useState(chat?.mark_eligible_for_challenge_at); 
  const isInitialRender = useRef(true); // Tracks whether it's the initial render

  useEffect(() => {
    if (isInitialRender.current){
      isInitialRender.current = false
      return;
    }
    const params = {
      has_mark: markEligibleForChallengeAt != null
    }
    ChallengeEligibilityCheckerService.toggleChallengeEligibility(chat.id, params).then(
      (data) => {},
      (error) => {
        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace('/eb/login');
        }
      }
    );
  }, [markEligibleForChallengeAt]); // eslint-disable-line

  return (
    <div className="covid-19-risk-checker">
      <h6 className="p-2">Mark User Chat Session Eligible For Challenge</h6>
      <Form.Check inline>
        <Form.Check.Input 
          id="markUserChatSessionEligibleForchallenge" 
          type="checkbox" 
          checked={markEligibleForChallengeAt != null}
          onChange={(e) => {
            setMarkEligibleForChallengeAt(e.target.checked ? Date.now() : null)
          }}/>
        <Form.Check.Label htmlFor="markUserChatSessionEligibleForchallenge">Mark User Chat Session Eligible For Challenge</Form.Check.Label>
      </Form.Check>
    </div>
  )
}

export default ChallengeEligibilityChecker;